import React from 'react'
import DocsListItem from './DocsListItem'

const DocsCard = ({section, title, description, feature1, feature2, feature3, feature4}) => {
    return (
        <>
            <div className="flex flex-col space-y-3 pt-9 md:pt-12 md:space-y-5 lg:space-y-7">

                <p className="text-base font-medium text-center text-primary md:text-lg font-roboto">{section}</p>

                <div className="w-11/12 mx-auto space-y-4 lg:w-full xl:w-4/5">
                    <h2 className="text-xl font-medium text-center text-secondary md:text-2xl font-roboto">{title}</h2>
                    <h3 className="w-full mx-auto text-sm font-normal leading-6 lg:w-4/5 text-secondary md:text-base lg:text-lg md:leading-7 lg:leading-9 font-roboto">{description}</h3>
                </div>

                <div className="grid items-start w-full grid-cols-1 mx-auto md:w-4/5 lg:w-4/5 xl:w-3/4 2xl:px-10 md:grid-cols-2 place-items-center gap-x-3 gap-y-2">
                        <DocsListItem text={feature1} />
                        <DocsListItem text={feature2} />
                        <DocsListItem text={feature3} />
                        <DocsListItem text={feature4} />
                </div>

            </div>
        </>
    )
}

export default DocsCard
